import React from 'react';
import {useTable, useGlobalFilter} from "react-table";
import {Table, TableCell, TableHeading, Skeleton} from "@nike/eds";
import {GlobalFilter} from "../util/GlobalFilter";

interface FilterableTableProps {
    data : object;
    columns : object;
    loading: boolean;
}

export function FilterableTable({ data, columns, loading } : FilterableTableProps) {

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state,
        setGlobalFilter

    } = useTable({
        columns,
        data,
        loading
    }, useGlobalFilter);

    const {globalFilter} = state

    return (
        <div className="eds-grid">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter}/>
            <Table {...getTableProps()}>
                <thead>
                {
                    headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {
                                    headerGroup.headers.map((column) => (
                                        <TableHeading {...column.getHeaderProps()}>{column.render('Header')}</TableHeading>
                                    ))
                                }
                                <th></th>
                            </tr>
                        )
                    )
                }
                </thead>
                <tbody {...getTableBodyProps()}>
                {
                    rows.map(row => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {
                                    row.cells.map((cell) => {
                                        return <TableCell
                                            /*{...cell.getCellProps()}*/
                                            key={cell.value}
                                        >{cell.render('Cell', {value: cell.value})}</TableCell>
                                    })
                                }
                                <td>

                                </td>
                            </tr>
                        )
                    })
                }
                { loading &&

                    headerGroups.map((headerGroup) => (
                            <React.Fragment>
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {
                                        headerGroup.headers.map(() => (
                                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                                        ))
                                    }
                                    <th></th>
                                </tr>
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {
                                        headerGroup.headers.map(() => (
                                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                                        ))
                                    }
                                    <th></th>
                                </tr>
                            </React.Fragment>
                        )
                    )
                }
                </tbody>
            </Table>
        </div>
    );
}
